module.exports = __webpack_public_path__ + "media/elevadizo/buqueIzquierda-dd-ap-ba2cb0c5.png";